<template>
    <div class="claim-step-wrap">
        <div class="line" />
        <div class="claim-step">
            <div
                v-for="i of stepCount"
                :key="i"
                :class="{'active': i === currentStep}"
                class="step-container">
                <span v-if="i === currentStep" class="icon icon-plane" />
                <span v-else class="dot">.</span>
                <div :class="{'active': i === currentStep}" class="step-name">
                    {{ stepNames[i-1] }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    props: ['stepCount', "currentStep", 'stepNames']
  }
</script>

<style lang="scss">
  @import '~@stylesheets/_vars.scss';

  .claim-step-wrap{
    user-select: none;
    position: relative;

    .line {
      top: 9px;
      width: 100%;
      position: absolute;
      border-bottom: 1px solid $gray_c;
    }

    .claim-step {
      position: relative;
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      html.tablet &, html.desktop & {
        margin-bottom: 60px;
      }

      .step-container {
        position: relative;
        width: 0;
        margin-right: 13px;
        margin-left: -5px;

        &.active {
          margin-right: 20px;
          margin-left: -2px;
        }

        .icon {
          color: $orange_a;
        }

        .dot {
          line-height: 0;
          color: $gray_c;
          font-size: 90px;
          position: absolute;
          top: -15px;
        }

        .step-name {
          bottom: -25px;
          color: $gray_c;
          position: absolute;
          white-space: nowrap;

          &.active {
            color: $light_black_b;
          }

          html.mobile & {
            display: none;
          }
        }

        &:nth-child(2), &:nth-child(3){
          .step-name{
            transform: translateX(-45%)
          }
        }

        &:last-child{
          .step-name{
            right: -15px;
          }
        }
      }
    }
  }
</style>